import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translations loaded inline here; full strings added in Batch 6
const resources = {
  en: {
    translation: {
      'nav.explore': 'Explore Projects',
      'nav.about':   'About',
      'nav.login':   'Log in',
      'nav.register':'Join as Talent',
    },
  },
  'zh-HK': {
    translation: {
      'nav.explore': '探索項目',
      'nav.about':   '關於我們',
      'nav.login':   '登入',
      'nav.register':'成為人才',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng:           'en',
    fallbackLng:   'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
